import { UseFormWatch } from 'react-hook-form';

import Button from '@/components/shared/Button/Button';

import { BlockFormData } from '../schema';

interface BlockFormHeaderProps {
  onCancel: () => void;
  editingSlug?: string;
  watch: UseFormWatch<BlockFormData>;
  attemptSave: () => void;
  isLoading: boolean;
}

const BlockFormHeader = ({
  onCancel,
  editingSlug,
  watch,
  attemptSave,
  isLoading,
}: BlockFormHeaderProps) => {
  return (
    <div className="flex gap-4 justify-between items-center">
      <h2 className="text-xl font-semibold text-neutral-90">
        <Button
          variant="transparent"
          className="border-none mr-4 w-fit text-xl !p-0 capitalize"
          prefixIcon={<img src="/icons/arrow-left.svg" alt="arrow-left" className="mr-4" />}
          onClick={onCancel}
          label={editingSlug ? 'Edit Block' : `Create New ${watch('type') || 'Block'}`}
        />
      </h2>
      <div className="flex gap-4">
        <Button
          type="button"
          onClick={attemptSave}
          disabled={isLoading}
          prefixIcon={<img src="/icons/save.svg" alt="save" />}
          label={isLoading ? 'Saving...' : 'Save Block'}
        />
      </div>
    </div>
  );
};

export default BlockFormHeader;
